import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.css';
import ErrorPage from './components/ErrorPage';
import Linktree from './components/Linktree';
function App() {
  return (
    <BrowserRouter>
    <div className="App">
      <Routes>
        <Route path='/'  element={<Linktree/>}/>
        <Route path='*'  element={<ErrorPage/>}/>
      </Routes>
    </div>
    </BrowserRouter>
    

  );
}

export default App;
